import { Button } from '../ui/Button';
import { getDifficultyColor, getLocalizedDifficultyLabel } from '../../utils/difficultyUtils';
import type { Word } from '../../types';
import { useTranslation } from 'react-i18next';

interface WordInfoProps {
  word: Word;
}

export default function WordInfo({ word }: WordInfoProps) {
  const { t } = useTranslation();

  return (
    <div className="bg-white rounded-lg shadow-md p-6">
      <div className="flex items-center justify-between mb-4">
        <h2 className="text-4xl font-bold text-blue-600">{word.word}</h2>
        <span
          className={`inline-block px-3 py-1 rounded-full text-sm font-medium ${
            getDifficultyColor(word.difficulty_level)
          }`}>
          {getLocalizedDifficultyLabel(word.difficulty_level, t)}
        </span>
      </div>
      <div className="flex items-center justify-between mb-6">
        <p className="text-lg text-gray-600 font-mono">/{word.phonetic_transcription}/</p>
        {word.audio_url && (
          <Button
            variant="ghost"
            size="md"
            onClick={() => word.audio_url && new Audio(word.audio_url).play()}
            className="ml-2"
          >
            <svg className="w-6 h-6 text-gray-500" fill="currentColor" viewBox="0 0 20 20">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15.536 8.464a5 5 0 010 7.072m2.828-9.9a9 9 0 010 12.728M5.858 18.142a9 9 0 010-12.728m2.828 9.9a5 5 0 010-7.072" />
            </svg>
          </Button>
        )}
      </div>

      <div className="space-y-4">
        <div>
          <h3 className="text-sm font-medium text-gray-700 mb-1">Definition:</h3>
          <p className="text-gray-600">{word.definition}</p>
        </div>

        {word.example_sentence && (
          <div>
            <h3 className="text-sm font-medium text-gray-700 mb-1">Example:</h3>
            <p className="text-gray-600 italic">&quot;{word.example_sentence}&quot;</p>
          </div>
        )}
      </div>
    </div>
  );
}